module.exports = __webpack_public_path__ + "static/media/flex-logo.d74fd499.svg";